import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ptBRJson from './translations/ptBR.json'
import enJson from './translations/en.json'
import esJson from './translations/es.json'

export const I18N_STORAGE_KEY = 'i18nextLng'
export const I18N_MANUAL_STORAGE_KEY = 'i18nextLngUserChoice'

const resources = {
  en: enJson,
  ptBR: ptBRJson,
  es: esJson,
};

const isManualLanguage = localStorage.getItem(I18N_MANUAL_STORAGE_KEY) === 'true'
const savedLanguage = localStorage.getItem(I18N_STORAGE_KEY)
const defaultLanguage = isManualLanguage && savedLanguage ? savedLanguage : (savedLanguage || 'ptBR');

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage, // Usa a linguagem salva ou o valor padrão
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
